// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_CancelarDespesaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /despesas/cancelar_despesa/{despesa_id}
 *
 * Cancels a despesa by setting its status to 3.
 * Returns a success message.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Despesas_CancelarDespesaResponseDados = string;

export type Despesas_CancelarDespesaResponse = ApiResponse<Despesas_CancelarDespesaResponseDados>;

registerResponseContract('Despesas_CancelarDespesaResponse', {})
